import { CommissionStatuses } from 'constants/commissionStatuses';

import React, { useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useCheckFinanceAccess } from 'hooks/useCheckFinanceAccess';
import { useCheckPaymentAccess } from 'hooks/useCheckPaymentAccess';
import { IconButton } from 'shared/mui/IconButtons';
import { ListItemIcon, ListItemText } from 'shared/mui/List';
import { Menu } from 'shared/mui/Menu/Menu';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';
import { commissionTaskAccess } from 'shared/widgets/CommissionsTabs/CommissionsTabsTask/utils/commissionTaskAccess';

interface CommissionsTableTaskStatusMenuProps {
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
  commissionStatus: CommissionStatuses;
}

export const CommissionsTabsTaskStatusMenu: React.FC<CommissionsTableTaskStatusMenuProps> = ({
  onView,
  onEdit,
  onDelete,
  commissionStatus,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { isHavePaymentAccess } = useCheckPaymentAccess();
  const { isHaveFinanceAccess } = useCheckFinanceAccess();
  const isRoleAccess = isHavePaymentAccess || isHaveFinanceAccess;

  const canEdit = commissionTaskAccess.canEdit(commissionStatus);
  const canDelete = commissionTaskAccess.canDelete(commissionStatus);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action: () => void) => {
    action();
    handleMenuClose();
  };

  return (
    <>
      <IconButton onClick={handleMenuOpen} size="small">
        <MoreHorizIcon fontSize="small" />
      </IconButton>
      <Menu
        MenuListProps={{
          disablePadding: true,
          sx: {
            '& .MuiMenuItem-root': {
              margin: '0 !important',
            },
          },
        }}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        open={open}
        slotProps={{
          paper: {
            sx: {
              padding: 0,
            },
          },
        }}
      >
        <MenuItem onClick={() => handleAction(onView)}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Просмотр" primaryTypographyProps={{ fontSize: 14 }} />
        </MenuItem>
        {isRoleAccess && canEdit && (
          <MenuItem onClick={() => handleAction(onEdit)}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Редактировать" primaryTypographyProps={{ fontSize: 14 }} />
          </MenuItem>
        )}
        {isRoleAccess && canDelete && (
          <MenuItem onClick={() => handleAction(onDelete)}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Удалить" primaryTypographyProps={{ fontSize: 14 }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
